import React, { Component } from "react";

class FloatingWidget extends Component {
    state = {
        isOpen: true
    };

    handleClose = () => {
        this.setState({ isOpen: false });
    };

    render() {
        const {
            headerText = "Header",
            bodyContent,
            footerContent,
            showWidget
        } = this.props;

        const { isOpen } = this.state;

        if (!showWidget || !isOpen) return null;

        return (
            <div style={styles.wrapper}>
                <div style={styles.card}>

                    {/* Header */}
                    <div style={styles.header} className="primary-gradient">
                        <span>{headerText}</span>
                        <span style={styles.close} onClick={this.handleClose}>
                            ✕
                        </span>
                    </div>

                    {/* Body */}
                    <div style={styles.body}>
                        {bodyContent}
                    </div>

                    {/* Footer */}
                    <div style={styles.footer}>
                        {footerContent}
                    </div>

                </div>

                {/* Animations */}
                <style>
                    {`
                        @keyframes spin {
                            0% { transform: rotate(0deg); }
                            100% { transform: rotate(360deg); }
                        }

                        @keyframes slideIn {
                            from {
                                transform: translateY(20px);
                                opacity: 0;
                            }
                            to {
                                transform: translateY(0);
                                opacity: 1;
                            }
                        }
                    `}
                </style>
            </div>
        );
    }
}

const styles = {
    wrapper: {
        position: "fixed",
        bottom: "24px",
        right: "24px",
        zIndex: 9999,
        animation: "slideIn 0.3s ease"
    },

    card: {
        width: "340px",
        background: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
        overflow: "hidden",
        fontFamily: "Inter, sans-serif"
    },

    header: {
        padding: "14px 16px",
        color: "#fff",
        fontWeight: "600",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
    },

    close: {
        cursor: "pointer",
        fontSize: "16px"
    },

    body: {
        background: "#eef2ff",   // ✅ same as your highlight
        padding: "12px",
        fontSize: "13px"
    },

    footer: {
        padding: "10px",
        borderTop: "1px solid #eee",
        fontSize: "14px"
    }
};

export default FloatingWidget;

 